import { API_BASE } from '@/lib/api';

export type UiModel = {
  id: string;
  label: string;
  color?: string;
  badge?: string;
  logo?: string;
  provider?: string;
};

const providerLogo: Record<string, string> = {
  openai: '/logo/gpt.jpg',
  google: '/logo/gemini.png',
  deepseek: '/logo/deepseek.png',
  auto: '/img/10633768.png',
  meta: '/logo/meta.jpg',
  perplexity: '/logo/sonar.png',
  anthropic: '/logo/claude.png',
};

export async function fetchUiModels(): Promise<UiModel[]> {
  const res = await fetch(`${API_BASE}/chat/models`, { credentials: 'include' });
  const data = await res.json();
  const flat: UiModel[] = Object.entries(data as Record<string, any>).flatMap(
    ([provider, entries]) =>
      Object.entries(entries as Record<string, any>)
        .filter(([key, id]) => {
          const k = String(key).toLowerCase();
          const v = String(id).toLowerCase();
          if (provider === 'deepseek' && (/^code(r)?$/.test(k) || /(deepseek)[-\/](code|coder)/.test(v))) return false;
          return true;
        })
        .map(([key, id]) => ({
          id: String(id),
          label: `${provider} (${key})`,
          provider,
          color:
            provider === 'openai'
              ? '#10b981'
              : provider === 'google'
              ? '#22c55e'
              : provider === 'anthropic'
              ? '#f59e0b'
              : provider === 'deepseek'
              ? '#0ea5e9'
              : provider === 'meta'
              ? '#374151'
              : provider === 'perplexity'
              ? '#64748b'
              : '#6b7280',
          badge: provider.slice(0, 2).toUpperCase(),
          logo: providerLogo[provider] || undefined,
        }))
  );
  return [
    { id: 'auto', label: 'Auto Router', color: '#F59E0B', badge: 'AR', logo: providerLogo['auto'], provider: 'auto' },
    ...flat,
  ];
}

